import {ID} from '~/lib/model';

export type AuctionCategory = 'performance' | 'branded';

export interface IBidderSummary {
    id: ID;
    title: string;
    agencyId: ID;
    agencyName?: string | null;
    tags: string[];
    endpoint?: string;
    datacenters?: string[];
    auctionCategory?: AuctionCategory;
    protocol?: string;
    delayedNotification?: boolean;
    maxQps?: number;
    maxBidFloor?: number | null;
    minBidFloor?: number | null;
    configIds?: number[];
    check?: boolean;
    dc?: string[];
    maxRpm?: number;
}

const normalizeString = (value: any): string | null => {
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'number') {
        return String(value);
    }
    if (value && typeof value === 'object') {
        if (typeof value.value === 'string') {
            return value.value;
        }
        if (typeof value.tag === 'string') {
            return value.tag;
        }
        if (typeof value.id === 'string' || typeof value.id === 'number') {
            return String(value.id);
        }
    }
    return null;
};

const normalizeStringArray = (values?: any): string[] => (Array.isArray(values) ? values
    .map(normalizeString)
    .filter((value): value is string => Boolean(value)) : []);

const normalizeNumberArray = (values?: any): number[] => (Array.isArray(values) ? values
    .map(value => {
        if (typeof value === 'number') {
            return value;
        }
        if (typeof value === 'string') {
            const parsed = Number(value);
            return Number.isFinite(parsed) ? parsed : null;
        }
        if (value && typeof value === 'object') {
            if (typeof value.id === 'number') {
                return value.id;
            }
            if (typeof value.value === 'number') {
                return value.value;
            }
        }
        return null;
    })
    .filter((value): value is number => value !== null) : []);

export const adaptBidderSummary = (bidder: any): IBidderSummary => ({
    id: bidder?.id ?? null,
    title: bidder?.title ?? '',
    agencyId: bidder?.agencyId ?? null,
    agencyName: bidder?.agencyName ?? null,
    tags: normalizeStringArray(bidder?.tags),
    endpoint: bidder?.endpoint ?? '',
    datacenters: normalizeStringArray(bidder?.datacenters ?? bidder?.dc),
    auctionCategory: bidder?.auctionCategory,
    protocol: bidder?.protocol,
    delayedNotification: bidder?.delayedNotification,
    maxQps: typeof bidder?.maxQps === 'number' ? bidder.maxQps : (typeof bidder?.maxRpm === 'number' ? bidder.maxRpm : undefined),
    maxBidFloor: bidder?.maxBidFloor ?? null,
    minBidFloor: bidder?.minBidFloor ?? null,
    configIds: normalizeNumberArray(bidder?.configIds),
    check: Boolean(bidder?.check)
});
